import { defineMessages } from 'react-intl';

export default defineMessages({
  created: {
    id: 'admin.companies.messages.create',
    defaultMessage: 'Module Run created successfully',
  },
  hiringCompanyCreated: {
    id: 'admin.companies.message.hiring.create',
    defaultMessage: 'Hiring Company Created Successfully',
  },
  updated: {
    id: 'admin.companies.messages.updated',
    defaultMessage: 'Module Run updated successfully',
  },
  confirmDelete: {
    id: 'admin.companies.messages.delete.confirm',
    defaultMessage: `<p class="lead">Are you sure you want to delete program <strong>{prettyId}</strong>?</p>`,
  },
});



// WEBPACK FOOTER //
// ./src/ui/admin/companies/messages.js